$(document).ready(function ($) {
  $("#suggest_variant").on("click", function (e) {
    e.preventDefault();
    suggest_variant();
  });
  $("#input_hip, #input_waist").on("input", function (e) {
     $('#size_text').html("");
  });

  function hip_function(hip_size) {
    if (hip_size >= 0 && hip_size <= 42) {
      return "xs";
    } else if (hip_size > 42 && hip_size <= 44) {
      return "s";
    } else if (hip_size > 44 && hip_size <= 46) {
      return "m";
    } else if (hip_size > 46 && hip_size <= 48) {
      return "l";
    } else if (hip_size > 48 && hip_size <= 50) {
      return "xl";
    } else if (hip_size > 50 && hip_size <= 52) {
      return "2xl";
    } else if (hip_size > 52 && hip_size <= 58) {
      return "3xl";
    } else if (hip_size > 58 && hip_size <= 64) {
      return "4xl";
    } else {
      return "";
    }
  }

  function suggest_variant() {
    var waist_size = parseInt(document.querySelector("#input_waist").value);
    var hip_size = parseInt(document.querySelector("#input_hip").value);
    var size = "";
    var hwd = hip_size - waist_size;
    var msg = `<p>Unfortunately, we do not recommend that you purchase a BDY Faja at this time due to your hip measurements exceeding the maximum for this garment. Please stay tuned as we work to be more inclusive with our sizes.</p>`;

    if (hwd <= 8) {
      if (waist_size > 44) {
      size = "";
      } else if (waist_size > 0 && waist_size <= 32) {
        size = "xs";
      } else if (waist_size > 32 && waist_size <= 34) {
        size = "s";
      } else if (waist_size > 34 && waist_size <= 36) {
        size = "m";
      } else if (waist_size > 36 && waist_size <= 38) {
        size = "l";
      } else if (waist_size > 38 && waist_size <= 40) {
        size = "xl";
      } else if (waist_size > 40 && waist_size <= 42) {
        size = "2xl";
      } else if (waist_size > 42 && waist_size <= 46) {
        size = "3xl";
      } else if (waist_size > 46 && waist_size <= 49) {
        size = "4xl";
      }else{
         size = "";
      } 
    } else if (hwd >= 9) {
      size = hip_function(hip_size);
    }
    
  if (size != "") {
       $(`.product__chip[data-option-value-dcase="${size}"]`).trigger('click');
       $('#size_text').html(`Your Size: ${size.toUpperCase()}`);
    }else{
      $('#size_text').html("<strong>No Size Recommended</strong>");
    $('#size_text').append(msg);
      }
    $('#sp_notices_wrapper').html("");
  }
});
